export default __webpack_public_path__ + "/dist/images/network.88af5558399b04048e6d43426537bf63.svg";